import { RejectedOrderSidePanel } from './RejectedOrderSidePanel';
import { connectRejectedOrderSidePanel } from './RejectedOrderSidePanel.connect';

export const ConnectedRejectedOrderSidePanel = connectRejectedOrderSidePanel(RejectedOrderSidePanel);
